
const additionalServicesList = [
	{ value: 1, text: "Descer pela escada" },
	{ value: 2, text: "Desmontar" },
];

const fetchAdditionalService = async () => {
	try {
		return additionalServicesList;
	} catch (error) {
		console.error(
			"additionalService.fetchAdditionalService",
			"Error get lines",
			error
		);
		return null;
	}
};

export const additionalService = {
	fetchAdditionalService,
};
